import { BookingFormField } from '@domain/booking-form-field';

// Allowed slugs array
const ALLOWED_SLUGS = ['firstName', 'lastName', 'email'] as const;

// Helper function to check booking form fields
export const checkBookingFormFieldsAllowed = (fields: BookingFormField[]) => {
  return fields.every((field) => ALLOWED_SLUGS.includes(field.slug as (typeof ALLOWED_SLUGS)[number]));
};
